import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { app } from '../../config';
import CalenderImg from '../../assets/images/calender.png';
import { useNavigate } from 'react-router-dom';
import { Pagination, Input, Form, Select, Row, Col, Space, Spin, message, Collapse, DatePicker } from 'antd';
//Collapse
import { CaretRightOutlined, CaretDownOutlined, SettingOutlined, LoadingOutlined } from '@ant-design/icons';
import moment from 'moment';
//Collapse End
import { useTranslation } from 'react-i18next';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { EditTwoTone, BranchesOutlined } from '@ant-design/icons';
import getHeaders from '../../utils/authHeaders';
import ListinngCard from '../../layouts/ListingCard';
import { dateConverter } from '../../utils/utcDateConversionCommon';

import EcommerceDashboardCard from '../../layouts/EcommerceDashboardCard';
import NoDataFound from '../../layouts/NoDataFound';
import SubOrderViewModal from './SubOrderViewModal';
import MainOrderViewModal from './MainOrderViewModal';
import EcomDashboardHeader from './EcomDashboardHeader';
import EcommerceCards from './EcommerceCards';
import { SearchBar } from '../../layouts/SearchBar';
import LoaderImage from '../LoaderImage';
import ViewOrderModal from './ViewOrderModal';
import EcomDashboardHeaderNew from './EcomDashboardHeaderNew';
import EcommerceCardsNew from './EcommerceCardsNew';

const CancelledOrRefund = () => {
  const { RangePicker } = DatePicker;
  const [activeIndex, setActiveIndex] = useState(1);
  const [cancelShow, setCancelShow] = useState(false);
  const [editbtn, setEditBtn] = useState('none');
  const [pageSize, setPageSize] = useState(10);
  const [fetchPartners, setFetchPartners] = useState([]);
  const [subOrderObj, setSubOrderObj] = useState({});
  const [pagesCount, setPagesCount] = useState(0);
  const [searchShow, setSearchShow] = useState({});
  const [renderList, setRenderList] = useState([]);
  const [tableShow, setTableShow] = useState(true);
  const [isCustomerRequest, setIsCustomerRequest] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [loader, setLoader] = useState(false);
  const [viewRequestLoader, setViewRequestLoader] = useState(false);
  const [showSingleRequest, setShowRequest] = useState(false);
  const [modalLoading, setModalLoading] = useState(false);
  const [requestObj, setRequestObj] = useState({});
const [iscancel,setiscancel]=useState(false)
  const [err, setErr] = useState('');
  const [tableHeaders, setTableHeaders] = useState([]);
  const [show, setShow] = useState(false);
  const [lockModalShow, setLockModalShow] = useState(false);
  const [delBatchResp, setDelBatchResp] = useState({});
  const [lockBatchResp, setLockBatchResp] = useState({});
  const [status, setStatus] = useState([]);
  // const [dashboardCardsCounts, setDashboardCardsCounts] = useState({
  //   totalInProgress: 0,
  //   totalInTransit: 0,
  //   totalDelivered: 0,
  //   totalCancelled: 0,
  //   totalReturnClaim: 0,
  // });
  const [cancelData, setCancelData] = useState({});
  const [orderCancelResp, setOrderCancelResp] = useState();
  const [cancelStatus, setCancelStatus] = useState(false);

  const [reciveBackData, setReciveBackData] = useState({});
  const [reciveBackResp, setReciveBackResp] = useState();
  const [reciveBackStatus, setReciveBackStatus] = useState(false);
  const [reciveBackShow, setReciveBackShow] = useState(false);
  const [isRecivedBack, setIsReciveBack] = useState(false);

  const [resendOrderData, setResendOrderData] = useState({});
  const [resendOrderResp, setResendOrderResp] = useState();
  const [resendOrderStatus, setResendOrderStatus] = useState(false);
  const [resendOrderShow, setResendOrderShow] = useState(false);
  const [viewPassedKey, setViewPassedKey] = useState();

  const [missingItem, setMissingItem] = useState(false);

  const [dispatchData, setDispatchData] = useState([]);
  const [dispatchShow, setDispatchShow] = useState(false);
  const [refreshPage, setRefreshPage] = useState(false);
  const [singleOrderOBj, setSingleOrderObj] = useState({});
  const [showSingleOrder, setShowSingleOrder] = useState(false);

  const [singleMainOrderOBj, setSingleMainOrderObj] = useState({});
  const [showSingleMainOrder, setShowSingleMainOrder] = useState(false);

  const handleClose = () => setShow(false);
  const handleLockClose = () => setLockModalShow(false);

  let navigate = useNavigate();
  let convertedObj;

  let searchFilters = [
    {
      fieldName: 'Order No.',
      fieldMappedBy: 'ecomOrderNo',
    },
    {
      fieldName: 'Customer',
      fieldMappedBy: 'patientName',
    },
  ];

  let inProgressHeaders = ['Order No.', 'Order Date', 'Customer', 'Action'];
  let inTransitHeaders = ['Order No.', 'Order Date', 'Customer', 'Action'];
  let deliveredHeaders = ['Order No.', 'Order Date', 'Customer', 'Action'];
  let customerRequestHeaders = ['Order No.', 'Order Date', 'Customer', 'Action'];
  let cancelledHeaders = ['Order No.', 'Order Date', 'Customer', 'Action'];

  let headersMap = new Map();
  headersMap.set(1, inProgressHeaders);
  headersMap.set(2, inTransitHeaders);
  headersMap.set(3, deliveredHeaders);
  headersMap.set(4, customerRequestHeaders);
  headersMap.set(5, cancelledHeaders);

  // {{base_url}}/api/v1/admin/ecomorders/orderscount
  let statusArr = [];

  useEffect(() => {
    const getState = async () => {
      const statusResp = await axios.get(`${app.URL}/api/v1/admin/ecomorders/orderscount`, { headers: getHeaders() });
      statusResp.data ? console.log(statusResp.data.result.data) : console.log('data');
      statusResp.status == 200 ? setStatus(statusResp.data.result.data) : ' ';
      console.log(status);
    };
    getState();
  }, []);
  console.log(status);

  const user = JSON.parse(localStorage.getItem('user'));
  if (user.userType === 'A') setEditBtn('block');
  const userRequestListingAPI = async (formData) => {
    console.log(formData);
    const partnerResp = await axios.post(`${app.URL}/api/v1/admin/userrequest/view`, formData, { headers: getHeaders() });
    // console.log(partnerResp)
    partnerResp ? console.log(partnerResp.data.result.data) : '';
    partnerResp ? (convertedObj = dateConverter(partnerResp.data.result.data.data, 'createdAt')) : ' ';
    partnerResp.data.result ? setFetchPartners(convertedObj) : ' ';
    partnerResp.data.result ? setPagesCount(partnerResp.data.result.data.count) : ' ';
    partnerResp.data.result ? setRenderList(convertedObj) : ' ';
  };
  const getCancelledRefundData = async (formData) => {
    console.log(formData);
    // setActiveIndex(1);
    setLoader(true);
    setSearchShow(formData)
    // let selector = formData?.dateSelector ? `&dateSelector=${formData?.dateSelector}` : "";
    // let orderDate = formData?.orderDateFrom ? `&dateFrom=${formData?.orderDateFrom}&dateTo=${formData?.orderDateTo}` : '';
  

    // const partnerResp = await axios.post(`http://localhost:3200/api/v1/admin/ecomorders/vieworders/5`, formData, { headers: getHeaders() });

    // const partnerResp = await axios.post(`${app.URL}/api/v1/admin/ecomorders/vieworders/5`, formData, { headers: getHeaders() });
    // console.log(partnerResp)
    const partnerResp = await axios.get(`${app.URL}/api/v1/admin/ecomorders/view?status=5`, formData, { headers: getHeaders() });
    // const partnerResp = await/ axios.get(`${app.URL}/api/v1/admin/ecomorders/view?status=5&limit=${formData?.limit}&offset=${formData?.offset}&searchBy=${formData?.searchBy}&searchTxt=${formData?.searchTxt}`, formData, { headers: getHeaders() });

    partnerResp ? console.log(partnerResp.data.result.data) : '';
    partnerResp ? (convertedObj = dateConverter(partnerResp.data.result.data.data, 'createdAt')) : ' ';
    partnerResp.data.result ? setFetchPartners(convertedObj) : ' ';
    partnerResp.data.result ? setPagesCount(partnerResp.data.result.data.count) : ' ';
    partnerResp.data.result ? setRenderList(convertedObj) : ' ';
    partnerResp.data.result && setLoader(false);
  };
  const getData = async () => {
    let formData = {
      limit: pageSize,
      offset: 0,
      searchBy: '',
      searchTxt: '',
    };
    console.log(formData);
    const partnerResp = await axios.post(`${app.URL}/api/v1/admin/userrequest/view`, formData, { headers: getHeaders() });
    console.log(partnerResp);
    partnerResp ? console.log(partnerResp.data.result.data) : ' ';
    partnerResp.data.result ? (convertedObj = await dateConverter(partnerResp.data.result.data.data, 'createdAt')) : ' ';
    partnerResp.data.result ? setFetchPartners(convertedObj) : ' ';
    partnerResp.data.result ? setPagesCount(partnerResp.data.result.data.count) : ' ';
    partnerResp.data.result ? setRenderList(convertedObj) : ' ';
    return console.log('return called');
  };
  const onRequestChange = async (page, pageSize) => {
    console.log(page, pageSize);
    setPageSize(pageSize);
    setCurrentPage(page);
    if (!page) page = 1;
    let limit = pageSize;
    try {
      let reqObj;
      if (Object.keys(searchShow).length !== 0) {
        reqObj = {
          limit: limit,
          offset: limit * (page - 1),
          // searchBy: searchShow.searchFor,
          // searchTxt: searchShow.searchItem,
        };
      } else {
        reqObj = {
          limit: limit,
          offset: limit * (page - 1),
          // searchBy: 'orderNo.',
          // searchTxt: '',
        };
      }
      console.log(reqObj);
      await userRequestListingAPI(reqObj);
    } catch (e) {
      console.log('Error');
      if (e.message) setErr(e.message);
      setTableShow(false);
    }
  };
  const onChange = async (page, pageSize) => {
    console.log(page, pageSize);
    setPageSize(pageSize);
    setCurrentPage(page);
    if (!page) page = 1;
    let limit = pageSize;
    try {
      let reqObj;
      if (Object.keys(searchShow).length !== 0) {
        reqObj = {
          limit: limit,
          offset: limit * (page - 1),
          searchBy: searchShow.searchBy,
          searchTxt: searchShow.searchTxt,
        };
      } else {
        reqObj = {
          limit: limit,
          offset: limit * (page - 1),
          searchBy: 'orderNo.',
          searchTxt: '',
        };
      }
      console.log(reqObj);
      await getCancelledRefundData(reqObj, activeIndex + 1);
    } catch (e) {
      console.log('Error');
      if (e.message) setErr(e.message);
      setTableShow(false);
    }
  };

  //Approve and Refund Workflow
  const handleCancelModalClose = () => setCancelShow(false);
  const cancelShipment = async (data) => {
    try {
      let resp = await axios.post(`${app.URL}/api/v1/admin/userrequest/cancelshipment`, data, { headers: getHeaders() });
      console.log('resp');
      setOrderCancelResp(resp.data.result);
      setCancelStatus(true);
      setTimeout(() => {
        setCancelShow(false);
      }, 500);
      await getData();
    } catch (e) {
      throw e;
    }
  };
  const onCancelTrigger = (data) => {
    setOrderCancelResp({});
    console.log(data);
    let cancelObj = {
      requestId: data.requestId,
      patientId: data.patientId,
      ecomOrderId: data.ecomOrderId,
      addressId: data.addressId,
    };

    console.log(cancelObj);
    setCancelShow(true);
    setCancelData(cancelObj);
  };
  const onCancelClick = async () => {
    console.log(cancelData);
    await cancelShipment(cancelData);
  };
  // Recive back order work flow

  const handleReciveBackModalClose = () => setReciveBackShow(false);
  const reciveorder = async (data) => {
    try {
      let resp = await axios.post(`${app.URL}/api/v1/admin/ecomorders/receiveback`, data, { headers: getHeaders() });
      console.log('resp');
      setReciveBackResp(resp.data.result);
      setReciveBackStatus(true);
      setTimeout(() => {
        setReciveBackShow(false);
      }, 500);
      await getData();
    } catch (e) {
      throw e;
    }
  };
  const onReciveBackTrigger = (data) => {
    setReciveBackResp({});
    console.log(data);
    let recivebackObj = {
      requestId: data.requestId,
      patientId: data.patientId,
      ecomOrderId: data.ecomOrderId,
      addressId: data.addressId,
    };

    console.log(recivebackObj);
    setReciveBackShow(true);
    setReciveBackData(recivebackObj);
  };
  const onReciveBackClick = async () => {
    console.log(reciveBackData);
    await reciveorder(reciveBackData);
  };

  //Recive back order workflow end

  //Resend Order Workflow

  const handleResendOrderModal = () => setResendOrderShow(false);
  const resendOrder = async (data) => {
    try {
      let resp = await axios.post(`${app.URL}/api/v1/admin/ecomorders/resendorder`, data, { headers: getHeaders() });
      console.log('resp');
      setResendOrderResp(resp.data.result);
      setResendOrderStatus(true);
      setTimeout(() => {
        setResendOrderShow(false);
      }, 500);
      await getData();
    } catch (e) {
      throw e;
    }
  };
  const onResendOrderTrigger = (data) => {
    setResendOrderResp({});
    console.log(data);
    if (data.requestType == 'Missing Item' || data.requestType == 'missing item') {
      setMissingItem(true);
    }
    let resendOrderObj = {
      requestId: data.requestId,
      patientId: data.patientId,
      ecomOrderId: data.ecomOrderId,
      addressId: data.addressId,
    };

    console.log(resendOrderObj);
    setResendOrderShow(true);
    setResendOrderData(resendOrderObj);
  };
  const onResendOrderonClick = async () => {
    console.log(resendOrderData);
    await resendOrder(resendOrderData);
  };

  //Resend Order Work flow End
  console.log(renderList);

  useEffect(() => {
    setTableHeaders(headersMap.get(1));
    let formData = {
      limit: pageSize,
      offset: 0,
      searchBy: '',
      searchTxt: '',
    };
    getCancelledRefundData(formData);
  }, [refreshPage]);

  let searchItems = [
    {
      name: 'Order No.',
      value: 'orderNo',
    },
    {
      name: 'Request No.',
      value: 'requestNo',
    },
    {
      name: 'Status',
      value: 'status',
    },
    {
      name: 'Type',
      value: 'requestType',
    },
  ];

  const { Panel } = Collapse;
  const customExpandIcon = (panelProps) => {
    const { isActive } = panelProps;

    return <span>{isActive ? <CaretDownOutlined /> : <CaretRightOutlined />}</span>;
  };

  const onCollapseChange = async (key) => {
    console.log('Collapse change:', key);
    console.log(key);
    // setSubOrderObj({})
    // const orderResp = await axios.post(`${app.URL}/api/v1/app/ecomorderdetails/view/${key}`, {}, { headers: getHeaders() });
    // console.log(orderResp)
    // let converArr = [];
    // orderResp.data.code == 200 ? converArr.push(orderResp.data.data) : " ";
    // orderResp.data.code == 200 ? convertedObj = await dateConverter(converArr, "orderDate") : " ";
    // orderResp.data.code == 200 ? setSubOrderObj(convertedObj[0]) : " "
  };
  console.log('subOrderObj', subOrderObj);
  console.log('singleOrderOBj', singleOrderOBj);

  const onViewClick = (data) => {
    console.log('onViewClick');
    console.log(data.ecomOrderId);
    localStorage.setItem('orderId', JSON.stringify(data.ecomOrderId));
    navigate('/ecomorders/view', { replace: true });
  };

  const onSearchFinish = async (values) => {
    console.log('onSearchFinish');
    console.log('Success:', values);
    let formData = {
      limit: 10,
      offset: 0,
      searchBy: values.searchBy, //partnerName, serialNo, orderNo
      searchTxt: values.searchTxt,
      // status: activeIndex, //1 = In-Transit (Inprogress), 2 = Sent to Lab, 3 = Completed
      // orderDateFrom: orderDateFrom ? orderDateFrom : '', //2023-03-03  only give date without time
      // orderDateTo: orderDateTo ? orderDateTo : '',
    };
    if (!formData.searchTxt) message.error('Please enter search text');
    else await getCancelledRefundData(formData);
  };

  const onSearchFinishFailed = (values) => {
    console.log('Failed:', values);
  };
  const onCardViewClick = (data) => {
    if (data == 1) {
      setActiveIndex(data);
      navigate('/ecom/dashboard/inprogress', { replace: true });
    } else if (data == 2) {
      setActiveIndex(data);
      navigate('/ecom/dashboard/intransit', { replace: true });
    } else if (data == 3) {
      setActiveIndex(data);
      navigate('/ecom/dashboard/delivered', { replace: true });
    } else if (data == 4) {
      setActiveIndex(data);
      navigate('/ecom/dashboard/request', { replace: true });
    } else if (data == 5) {
      setActiveIndex(data);
      navigate('/ecom/dashboard/cancel', { replace: true });
    }
  };

  const [isModalLoading, setIsModalLoading] = useState(false);

  const getMainOrderData = async (id) => {
    try {
      let resp = await axios.get(`${app.URL}/api/v1/admin/ecomorders/view/${id}`, { headers: getHeaders() });
      // console.log("main order get api response: ", resp.data.result.data );
      // setSingleMainOrderObj(resp.data.result.data);
      // setSubOrderObj(resp.data.result.data);

      // console.log("sub order obj modal api before: ", subOrderObj);
      // console.log("main order single obj modal api before: ", singleMainOrderOBj);

      setSingleMainOrderObj(resp.data.result.data);

      console.log('main order obj: ', singleMainOrderOBj);

      setIsModalLoading(!isModalLoading);

      // console.log("sub order obj modal api after: ", subOrderObj);
      // console.log("main order single obj modal api after: ", singleMainOrderOBj);
    } catch (error) {
      console.log('Error: ', error);
    }
  };

  const [mainOrderObj, setMainOrderObj] = useState({});

  const mainOrderModal = (order) => {
    console.log('Main Order Modal Running');
    const getData = async () => {
      let resp = await axios.get(`${app.URL}/api/v1/admin/ecomorders/view/${order.ecomOrderId}`, { headers: getHeaders() });
      setMainOrderObj(resp.data.result.data);
      setSingleMainOrderObj(resp.data.result.data);
      openMainOrderModal();
    };

    getData();
  };

  const openMainOrderModal = () => {
    setShowSingleMainOrder(true);
  };
  const getRequest = async (requestId) => {
    console.log('get single sub order');
    // console.log(ecomOrderId, addressId);
    try {
      let resp = await axios.get(`${app.URL}/api/v1/admin/userrequest/view/${requestId}`, { headers: getHeaders() });
      console.log('View Order Resp', resp);
      console.log(resp);
      let shipmentResp;
      resp ? (shipmentResp = resp.data.result.data) : '';
      return shipmentResp;
    } catch (e) {
      throw e;
    }
  };
  const getSingleSubOrder = async (ecomOrderId, addressId, patientId) => {
    console.log('get single sub order');
    console.log(ecomOrderId, addressId);
    try {
      let resp = await axios.get(`${app.URL}/api/v1/admin/ecomorders/vieworder?orderId=${ecomOrderId}&patientId=${patientId}&addressId=${addressId ? addressId : ''}`, { headers: getHeaders() });
      // let resp = await axios.get(`http://localhost:3200/api/v1/admin/ecomorders/vieworder?orderId=${ecomOrderId}&patientId=${patientId}&addressId=${addressId ? addressId : ''}`, { headers: getHeaders() });

      console.log('View Order Resp', resp);
      console.log(resp);
      let shipmentResp;
      resp ? (shipmentResp = resp.data.result.data) : '';
      return shipmentResp;
    } catch (e) {
      throw e;
    }
  };

  const onnewViewClick = async (data, key) => {
    console.log('Data', data, 'Key', key);
    setViewPassedKey(key);
    setModalLoading(true);
    console.log('onViewClick');
    console.log(data.ecomOrderId, data.addressId);
    let apiResp = await getSingleSubOrder(data.ecomOrderId, data.address[0].addressId, data.patientId);
    console.log('apiResp', apiResp);
    // console.log(apiResp);
    let createdAt = moment(apiResp.createdAt).utc().format('DD-MMM-YYYY');
    apiResp.createdAt = createdAt;
    apiResp ? setSubOrderObj(apiResp) : '';
    setModalLoading(false);
    setViewPassedKey(null);
    setShowSingleOrder(true);
    setSingleOrderObj(data);
    // localStorage.setItem("orderId", JSON.stringify(data.ecomOrderId));
    // navigate('/ecomorders/view', { replace: true })
  };



  const onViewRequest = async (data, key) => {
    console.log('Data', data, 'Key', key);
    console.log('Data', data, 'Key', key);
    setViewPassedKey(key);
    setViewRequestLoader(true);
    console.log('onViewClick');
    console.log(data.ecomOrderId, data.addressId);
    let apiResp = await getRequest(data.address[0].requestId);
    console.log('apiResp Request', apiResp);
    console.log(apiResp);
    let createdAt = moment(apiResp.createdAt).utc().format('DD-MMM-YYYY');
    apiResp.createdAt = createdAt;
    apiResp ? setRequestObj(apiResp) : '';
    setViewRequestLoader(false);
    setViewPassedKey(null);
    setShowRequest(true);
  };


  
  const genExtra = (order, key) => (
    // <table className=' mb-2 p-0 pt-0 pb-0'>
    <tbody
      id='customer'
      className='pt-0 pb-0 w-100'
      style={
        {
          // marginLeft: '10px',
        }
      }
    >
      <tr className='p-0'>
        <td
          className='text-center '
          style={{
            width: '12.5%',
            // width: '200px',
            padding: '0px 0px !important',
          }}
        >
          {order.reqNo}
        </td>
        <td
          className='text-center    '
          style={{
            width: '12.5%',
            // width: '200px',

            padding: '0px 0px !important',

            // width: '150px',
            // width: '17.5%',
            // paddingLeft: '5px',
          }}
        >
          {`${order.ecomOrderNo}${order.address[0]?.addressId ? `-${order.address[0]?.addressId}` : ''}`}
        </td>
        <td
          className='text-center '
          style={{
            width: '12.5%',
            // width: '150px',
            padding: '0px 0px !important',

            // width: '25.5%',
          }}
        >
          {order.reqTypeName}
        </td>
        <td
          className='text-center  '
          style={{
            width: '12.5%',
            // width: '150px',
            padding: '0px 0px !important',

            // width: '23.5%',
            // paddingLeft: '25px',
          }}
        >
          {moment(order.requestDate).format('MM-DD-YYYY')}
        </td>
        <td
          className='text-center '
          style={{
            width: '12.5%',
            // width: '200px',
            padding: '0px 0px !important',

            // paddingLeft: '35px',

            // width: '30.5%',
          }}
        >
          {order.refundDate ? moment(order.refundDate).format('MM-DD-YYYY') : '-'}
        </td>
        <td
          className='text-center  '
          style={{
            padding: '0px 0px !important',

            width: '12.5%',
            // width: '158px',
            // wdth: '23.5%',
            // padddingLeft:'200px'
          }}
        >
          {order.transactionNo ? order.transactionNo : '-'}
        </td>
        <td
          className='text-center '
          style={{
            width: '12.5%',
            // width: '150px',
            padding: '0px 0px !important',

            // width: '12.5%',
            // paddingLeft: '50px',
          }}
        >
          {order.requestStatus}
        </td>
        {/* <td
            className='text-center '
            style={{
              width: '12.5%',
            }}
          >
            <Button
              onClick={() => {
                // getMainOrderData(order.ecomOrderId);
                mainOrderModal(order);
              }}
              style={{ width: '80px', height: '34px', fontSize: 'small', marginLeft: '30px' }}
              // className='mx-3'
              size='small'
            >
              View
            </Button>
          </td> */}
        <td
          className='text-center '
          style={{
            width: '12.5%',
            //  width: '150px'
            padding: '0px 0px !important',
// paddingLeft:'60px'
            // width: '12.5%',
            // alignItems: 'r/ight',
          }}
        >
          <td
            className='text-center  '
            style={
              {
                // padding: '0px 0px !important',
                // width: '6.0%',
              }
            }
          >
            <button
              className='button btn btn-primary mx-1'
              onClick={() => {
                onnewViewClick(order, key);
              }}
              style={{
                whiteSpace: 'nowrap', // ✅ camelCase and comma!
              }}
              size='medium'
            >
              {modalLoading && viewPassedKey == key ? <LoadingOutlined /> : 'View Order'}
            </button>
          </td>

          <td
            className='text-center '
            style={
              {
                // width: '6.1%',
              }
            }
          >
            <button
              className='button btn btn-primary mx-1'
              style={{
                whiteSpace: 'nowrap', // ✅ camelCase and comma!
              }}
              onClick={() => {
                onViewRequest(order, key);
              }}
              size='medium'
            >
              {viewRequestLoader && viewPassedKey == key ? <LoadingOutlined /> : 'View Request'}
            </button>
          </td>
        </td>
      </tr>
    </tbody>
    // </table>
  );

  console.log('setSubOrderObj', subOrderObj);
  console.log('singleOrderOBj', singleOrderOBj);

  useEffect(() => {
    let resp;
    Object.keys(subOrderObj).length > 0 ? (resp = subOrderObj.address.filter((ele) => ele.requestId)) : '';
    console.log(resp);
    resp && resp.length > 0 ? setIsCustomerRequest(true) : setIsCustomerRequest(false);
  }, [subOrderObj]);

  const handleOnChange = (e) => {
    // console.log("e",e)
    if (e.target.value.length === 0) {
      setRefreshPage(!refreshPage);
      setSearchShow({});
    }
  };
  return (
    <div className='dashboard-card container-fluid'>
      <EcomDashboardHeaderNew onChange={onChange} />
      <EcommerceCardsNew status={status} onCardViewClick={onCardViewClick} />
      <SearchBar onFinish={onSearchFinish} onFinishFailed={onSearchFinishFailed} searchItems={searchItems} onChange={handleOnChange} iscancel={iscancel} cancref={true} setiscancel={setiscancel} />

      {/* orders table to copy*/}

      {loader && <LoaderImage />}
      {renderList.length > 0 && !loader ? (
        <div className='row table-scrollbar'>
          <table
            id='customer'
            // style={{
            //   width: 'auto', // Table shrinks to fit content
            //   tableLayout: 'auto', // Let the browser decide column widths based on content
            //   borderCollapse: 'collapse',
            // }}
            className=' mb-2  pt-0 pb-0 '
            style={
              {
                // paddingLeft: '100px !important',
              }
            }
          >
            {/* <table > */}

            <thead className=''>
              <tr>
                {['Request No.', 'Order No.', 'Request Type', 'Request Date', 'Refund Initiate Date', ' Transaction No.', 'Request Status', 'Action', ' ', ' '].map((item) => (
                  <th key={item} style={{ fontWeight: 'bold', width: '12.5%', textAlign: 'center' }}>
                    {item}
                  </th>
                ))}
              </tr>
            </thead>
            {/* </table> */}

            {/* <div> */}
            {renderList.map((order, index) => (
              <React.Fragment key={index} style={{ marginTop: '0px' }}>
                {genExtra(order, index)}
              </React.Fragment>
            ))}
            {/* </div> */}
          </table>
        </div>
      ) : (
        <>{!loader && <NoDataFound />}</>
      )}

      <div className='row'>{currentPage && pagesCount ? <Pagination style={{ marginTop: '10px' }} onChange={activeIndex == 4 ? onRequestChange : onChange} defaultCurrent={currentPage} total={pagesCount} showTotal={(total) => `Total ${total} items`} showSizeChanger /> : ' '}</div>
      <ViewOrderModal isVisible={showSingleRequest} setIsVisible={setShowRequest} requestObj={requestObj} />

      {/* main order view modal start */}

      <MainOrderViewModal
        isVisible={showSingleMainOrder}
        setIsVisible={setShowSingleMainOrder}
        ecomOrderNo={singleMainOrderOBj.ecomOrderNo}
        ecomOrderCreatedData={moment(singleMainOrderOBj.createdAt).format('MM-DD-YYYY')}
        // patientName={"singleMainOrderOBj.patientName"}
        productTotalAmount={singleMainOrderOBj.totalProductAmount}
        shipmentTotal={singleMainOrderOBj.totalShipmentCharges}
        subOrdersData={singleMainOrderOBj?.orderDetails}
        isLoading={isModalLoading}
        setIsLoading={setIsModalLoading}
        mainOrderShipmentAmount={singleMainOrderOBj.totalShipmentCharges}
        mainOrderGrandTotal={singleMainOrderOBj.grandTotalAmount}
        totalProductAmount={singleMainOrderOBj.totalProductAmount}
        ecomOrderId={singleMainOrderOBj.ecomOrderId}
        isApiCallAble={false}
        last4={singleMainOrderOBj?.last4}
      />

      {/* main order view modal end */}

      {/* single sub order view modal start */}
      {/* viewOrder btn clicked this mmodal opens */}
      <SubOrderViewModal
        viewOrder={true}
        isVisible={showSingleOrder}
        ecomOrderId={subOrderObj?.ecomOrderId}
        setIsVisible={setShowSingleOrder}
        address={subOrderObj?.address}
        ecomOrderCreatedDate={subOrderObj?.createdAt}
        ecomOrderNo={subOrderObj?.ecomOrderNo}
        subOrderObj={subOrderObj}
        overallProductTotal={subOrderObj?.overallProductTotal}
        taxAmount={subOrderObj?.taxAmount}
        shipmentCharges={subOrderObj?.shipmentCharges}
        grandTotal={subOrderObj?.grandTotal}
        singleOrderOBj={singleOrderOBj}
        ischeck={true}
        // ecomOrderNo={`${subOrderObj.ecomOrderNo}-${subOrderObj.addressId}`}

        // address={`${subOrderObj.address}, ${subOrderObj.state}, ${subOrderObj.city}, ${subOrderObj.zipCode}`}
        // productsData={subOrderObj?.products}
        // status={subOrderObj.status}
        // title={subOrderObj.title}
        // shipmentCharges={subOrderObj.shipmentTotal}
        // grandTotal={subOrderObj.grandTotal}
        // totalShipmentAmount={subOrderObj.grandTotal}
        // tax={subOrderObj.taxAmount}
        // requestId={subOrderObj.requestId}
        // requestStatus={subOrderObj.requestStatus}
        // requestType={subOrderObj.requestType}
        // shipmePackageName={subOrderObj.shipmentPackage}
        locationURL={window.location.pathname}
        last4={subOrderObj?.last4}
      />

      {/* single sub order view modal end */}

      {/* Cancel Modal */}
      {orderCancelResp && orderCancelResp.code === 200 ? (
        <Modal show={cancelShow} onHide={handleCancelModalClose}>
          <Modal.Header closeButton>
            <Modal.Title className='text-center'>Success</Modal.Title>
          </Modal.Header>
          <Modal.Body>{orderCancelResp.msg}</Modal.Body>
          <Modal.Footer></Modal.Footer>
        </Modal>
      ) : orderCancelResp && orderCancelResp.code === 400 ? (
        <Modal show={cancelShow} onHide={handleCancelModalClose}>
          <Modal.Header closeButton>
            <Modal.Title className='text-center'>Failed</Modal.Title>
          </Modal.Header>
          <Modal.Body>{orderCancelResp.msg}</Modal.Body>
          <Modal.Footer></Modal.Footer>
        </Modal>
      ) : (
        <Modal show={cancelShow} onHide={handleCancelModalClose}>
          <Modal.Header closeButton>
            <Modal.Title>Confirmation</Modal.Title>
          </Modal.Header>
          <Modal.Body>Are you sure you want to cancel shipment?</Modal.Body>
          <Modal.Footer>
            <Button variant='secondary' onClick={handleCancelModalClose}>
              Cancel
            </Button>
            <Button variant='primary' htmlType='submit' onClick={onCancelClick}>
              Confirm
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      {/* Recive Back Modal */}
      {reciveBackResp && reciveBackResp.code === 200 ? (
        <Modal show={reciveBackShow} onHide={handleReciveBackModalClose}>
          <Modal.Header closeButton>
            <Modal.Title className='text-center'>Success</Modal.Title>
          </Modal.Header>
          <Modal.Body>{reciveBackResp.msg}</Modal.Body>
          <Modal.Footer></Modal.Footer>
        </Modal>
      ) : reciveBackResp && reciveBackResp.code === 400 ? (
        <Modal show={reciveBackShow} onHide={handleReciveBackModalClose}>
          <Modal.Header closeButton>
            <Modal.Title className='text-center'>Failed</Modal.Title>
          </Modal.Header>
          <Modal.Body>{reciveBackResp.msg}</Modal.Body>
          <Modal.Footer></Modal.Footer>
        </Modal>
      ) : (
        <Modal show={reciveBackShow} onHide={handleReciveBackModalClose}>
          <Modal.Header closeButton>
            <Modal.Title>Confirmation</Modal.Title>
          </Modal.Header>
          <Modal.Body>Are you sure, you want to recive shipment back?</Modal.Body>
          <Modal.Footer>
            <Button variant='secondary' onClick={handleReciveBackModalClose}>
              Cancel
            </Button>
            <Button variant='primary' htmlType='submit' onClick={onReciveBackClick}>
              Confirm
            </Button>
          </Modal.Footer>
        </Modal>
      )}

      {/* Resend Order Modal */}
      {resendOrderResp && resendOrderResp.code === 200 ? (
        <Modal show={resendOrderShow} onHide={handleResendOrderModal}>
          <Modal.Header closeButton>
            <Modal.Title className='text-center'>Success</Modal.Title>
          </Modal.Header>
          <Modal.Body>{resendOrderResp.msg}</Modal.Body>
          <Modal.Footer></Modal.Footer>
        </Modal>
      ) : resendOrderResp && resendOrderResp.code === 400 ? (
        <Modal show={resendOrderShow} onHide={handleResendOrderModal}>
          <Modal.Header closeButton>
            <Modal.Title className='text-center'>Failed</Modal.Title>
          </Modal.Header>
          <Modal.Body>{resendOrderResp.msg}</Modal.Body>
          <Modal.Footer></Modal.Footer>
        </Modal>
      ) : (
        <Modal show={resendOrderShow} onHide={handleResendOrderModal}>
          <Modal.Header closeButton>
            <Modal.Title>Confirmation</Modal.Title>
          </Modal.Header>
          <Modal.Body>{missingItem ? `Are you sure, you want to send the missing item?` : `Are you sure, you want to resend the order?`}</Modal.Body>
          <Modal.Footer>
            <Button variant='secondary' onClick={handleResendOrderModal}>
              Cancel
            </Button>
            <Button variant='primary' htmlType='submit' onClick={onResendOrderonClick}>
              Confirm
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </div>
  );
};

export default CancelledOrRefund;